/**
 * @desc 样品确认-审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductConfirmApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
